import React from "react";

import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);
export function ModalCausaObservaciones(callBack: (resp: string) => void) {
  Array.from(document.getElementsByClassName("modalAgregarCausa")).shift()?.removeAttribute("tabIndex");//   
  MySwal.fire({
    html: <div>
    <h4>Ingrese Observación:</h4>
  </div>,
    input: 'textarea',
    inputAttributes: {
      autocapitalize: 'off'
    },
    showCancelButton: true,
    confirmButtonText: 'Aceptar',
    cancelButtonText: 'Cancelar',
    showLoaderOnConfirm: true,
    preConfirm: async(txtMotivo) => {
      if(!txtMotivo){
        Swal.showValidationMessage(
          `Debe ingresar una observación`
        );
      }else{
        callBack(txtMotivo);
      }
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    if (result.isConfirmed) {
      console.log("");
    }
  });
}
export function ModalCausaRechazo(callBack: (resp: string) => void) {
  Array.from(document.getElementsByClassName("modalAgregarCausa")).shift()?.removeAttribute("tabIndex");
  MySwal.fire({
    html: <div>
      <h4>Motivo del Rechazo:</h4>
    </div>,
    input: 'textarea',
    inputAttributes: {
      autocapitalize: 'off'
    },
    showCancelButton: true,
    confirmButtonText: 'Rechazar',
    cancelButtonText: 'Cancelar',
    showLoaderOnConfirm: true,
    preConfirm: async(txtMotivo) => {
      if(!txtMotivo){
        Swal.showValidationMessage(
          `Debe ingresar un motivo`
        );
      }else{
        callBack(txtMotivo);
      }
    },
    allowOutsideClick: () => !Swal.isLoading()
  }).then((result) => {
    if (result.isConfirmed) {
      console.log("");
    }
  });
}

export function ModalConfirmacionCierre(callBack: () => void) {
  MySwal.fire({
    html: <div>
      <h3>Confirmar Cierre</h3>
      <div>¿Está seguro que desea cerrar la causa?</div>
    </div>,
    icon: 'question',
    confirmButtonText: "Aceptar",
    cancelButtonText: "Cancelar",
    showCloseButton: true,
    showCancelButton: true,
  }).then((result) => {
    if(result.isConfirmed){
      callBack();
    }
  });
}
